"use client";

interface Props {
    icon: string;
    label: string;
    onClick?: () => void;
    tone: "flame" | "journey" | "gigs";
}

const TONE_STYLES: Record<Props["tone"], string> = {
    flame:   "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100",
    journey: "bg-[#e8f4f5] text-[#007a8a] border-[#b3dfe6] hover:bg-[#d0edf2]",
    gigs:    "bg-[#f0f2f4] text-[#003d45] border-[#d0d5da] hover:bg-[#e4e8ec]",
};

export function GamificationChip({ icon, label, onClick, tone }: Props) {
    return (
        <button
            onClick={onClick}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-bold transition-colors ${TONE_STYLES[tone]}`}
        >
            <span className="material-symbols-outlined text-[14px]">{icon}</span>
            {label}
        </button>
    );
}
